import { GET_LEADERBOARD } from './leaderboard.types';

export const getLeaderboard = () => {
  return {
    type: GET_LEADERBOARD,
  };
};
